import React from 'react';
import { TableHead } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import {StyledTableRow,StyledTableCell,StyledTableSortLabel}  from './StyledTable'

const useStyles = makeStyles((theme) => ({
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }));

function MuiTableHeader(props) {
  const classes = useStyles();
  const { order, orderBy, onRequestSort, headCells, stickyHeader, hideSortArrows } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const stickyProps = stickyHeader
  ? {
      sx: {
        position: 'sticky',
        top: 0,
        background: '#fff',
        zIndex: 2,
      },
    }
  : {};

  return (
    <TableHead>
      <StyledTableRow>
        {headCells.map((headCell) => {
          const cellType = headCell.type || 'sortable';
          const alignment = headCell.align || (headCell.numeric ? 'right' : 'left');  // default to left if no align specified
          const hiddenHeaderText = headCell.hiddenHeader || headCell.label || '';

          if (cellType === 'blank') {
            return (
              <StyledTableCell key={headCell.id} align={alignment} {...stickyProps}>
                <span className={classes.visuallyHidden}>{hiddenHeaderText}</span>
              </StyledTableCell>
            );
          } else if (cellType === 'noSort' || hideSortArrows) {
            return (
              <StyledTableCell key={headCell.id} align={alignment} {...stickyProps}>
                {headCell.label}
              </StyledTableCell>
            );
          } else {
            return (
              <StyledTableCell
                key={headCell.id}
                align={alignment}
                sortDirection={orderBy === headCell.id ? order : false}
                {...stickyProps}
              >
                <StyledTableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </StyledTableSortLabel>
              </StyledTableCell>
            );
          }
        })}
      </StyledTableRow>
    </TableHead>
  );
}

MuiTableHeader.propTypes = {
  onRequestSort: PropTypes.func,
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  headCells: PropTypes.array,
};

export default MuiTableHeader